import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { TextField, Grid } from '@mui/material'

import BaseDialog from '../../../BaseDialog'

import { useDataApi } from '../../../../context/DataApiContext'
import { useNotificationsProvider } from '../../../../context/NotificationsContext'
import AutoCompleteInput from '../../../AutoCompleteInput'

export default function CreateConstructorDialog({ open, onClose, onCreated }) {
  const { t } = useTranslation()

  const { dataProvider } = useDataApi()
  const { showNotification } = useNotificationsProvider()

  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const [name, setName] = useState('')
  const [address, setAddress] = useState('')
  const [siret, setSiret] = useState('')
  const [vehicleTypeIds, setVehicleTypeIds] = useState([])
  const [controlLocations, setControlLocations] = useState([])

  const resetState = () => {
    // Clean form
    setLoading(false)
    setError('')
    setName('')
    setAddress('')
    setSiret('')
    setVehicleTypeIds([])
    setControlLocations([])
  }

  const onCloseDialog = (event, reason) => {
    if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
      onClose()
    } else {
      resetState()
      onClose()
    }
  }

  const onConfirm = () => {
    if (name.length === 0) {
      setError('name_required')
      return
    }

    if (vehicleTypeIds.length === 0) {
      setError('vehicleTypeIds_required')
      return
    }

    setLoading(true)
    dataProvider.constructor
      .post(
        name,
        address,
        siret,
        vehicleTypeIds.map((type) => type.id),
        controlLocations.map((loc) => loc.id)
      )
      .then(() => {
        dataProvider.cache.reset()
        showNotification('success', t('create-constructor-dialog.success'))
        onCreated()
        resetState()
      })
      .catch((err) => {
        if (err.response.data.error === 'CONSTRUCTOR_ALREADY_EXISTS') {
          showNotification(
            'error',
            t('create-constructor-dialog.already-exists-error')
          )
        } else {
          showNotification('error', t('errors.api-error'))
        }
        setLoading(false)
      })
  }
  return (
    <BaseDialog
      open={open}
      onClose={onCloseDialog}
      onConfirm={onConfirm}
      title={t('create-constructor-dialog.title')}
      loading={loading}
    >
      <Grid container direction="column" spacing={4}>
        <Grid item>
          <TextField
            variant="standard"
            required
            error={error === 'name_required'}
            helperText={t('common.required')}
            id="name"
            label={t('create-constructor-dialog.constructor-name')}
            fullWidth
            value={name}
            onChange={(event) => setName(event.target.value)}
          />
        </Grid>
        <Grid item>
          <TextField
            variant="standard"
            id="address"
            label={t('create-constructor-dialog.constructor-address')}
            fullWidth
            multiline
            rows={2}
            value={address}
            onChange={(event) => setAddress(event.target.value)}
          />
        </Grid>
        <Grid item>
          <TextField
            variant="standard"
            id="siret"
            label={t('create-constructor-dialog.constructor-siret')}
            fullWidth
            value={siret}
            onChange={(event) => setSiret(event.target.value)}
          />
        </Grid>
        <Grid item>
          <AutoCompleteInput
            onChange={setVehicleTypeIds}
            label={t('create-constructor-dialog.vehicle-type')}
            resource="/constructors/autocomplete-vehicle-types"
            error={error === 'vehicleTypeIds_required'}
            helperText={t('common.required')}
            value={vehicleTypeIds}
            multiple
            required
            canDelete
          />
        </Grid>
        <Grid item>
          <AutoCompleteInput
            onChange={setControlLocations}
            value={controlLocations}
            label={t('modify-constructor-dialog.control-locations')}
            resource="control/location-autocomplete"
            multiple
            canDelete
          />
        </Grid>
      </Grid>
    </BaseDialog>
  )
}
